import styled from 'styled-components'


export const BackToCart = styled.img`
    padding-top: 70px;
    padding-left: 5px;
    font-weight: bold;


` 
export const EntireWrapper = styled.div`
    background-color: #FFF7DF;
    border-radius: 20px;
    margin: 1rem 0 5rem 0;
    box-sizing: border-box;
    

`
export const TitleDiv = styled.div`
    font-weight: bold;
    padding: 40px;
    display: flex;
    justify-content: center;
    align-items: baseline;
    border-bottom: solid 1px #E5E5E5;
`
export const TitlePicture = styled.img`
    


`
export const TitleParagraph = styled.p`
    margin-top: 0;
    align-self: flex-end;
    margin-right: 10px;
`